var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styles from './AddProjectReaders.module.scss';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { PersonPicker } from '@app/Components/Pickers/PersonPicker/PersonPicker';
import Person from '@app/Widgets/Meeting/Participants/Person/Person';
import { MdClose } from 'react-icons/md';
import { Modal } from '@app/Components/Modal/Modal';
var AddProjectReadersC = /** @class */ (function (_super) {
    __extends(AddProjectReadersC, _super);
    function AddProjectReadersC() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._projectReaders = [];
        return _this;
    }
    AddProjectReadersC.prototype._handleUserSelect = function (users) {
        if (users === null || users === void 0 ? void 0 : users.length) {
            var index = this._projectReaders.indexOf(users[0]);
            if (index === -1) {
                this._projectReaders.push(users[0]);
            }
        }
    };
    AddProjectReadersC.prototype._handleUserRemove = function (user) {
        var index = this._projectReaders.indexOf(user);
        if (index !== -1) {
            this._projectReaders.splice(index, 1);
        }
    };
    AddProjectReadersC.prototype._handleClose = function () {
        this._projectReaders = [];
        this._toggleModal();
    };
    AddProjectReadersC.prototype._handleSave = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onSave(this._projectReaders)];
                    case 1:
                        _a.sent();
                        this._projectReaders = [];
                        this._toggleModal();
                        return [2 /*return*/];
                }
            });
        });
    };
    AddProjectReadersC.prototype._toggleModal = function () {
        var _a = this.props, history = _a.history, match = _a.match;
        history.push(match.url);
    };
    AddProjectReadersC.prototype.render = function () {
        var _this = this;
        var match = this.props.match;
        return (React.createElement("div", { className: styles.container },
            React.createElement(Switch, null,
                React.createElement(Route, { path: "".concat(match.url, "/add") },
                    React.createElement(Modal, { isOpen: true, toggle: this._handleClose, headerTitle: "Add Project Readers", maxWidth: "550px", footerbuttons: this._getFooterButtons() },
                        React.createElement("div", { className: styles.addPrincipal },
                            React.createElement("div", { style: { width: '100%' } },
                                React.createElement(PersonPicker, { onUsersSelect: this._handleUserSelect, exceptIds: this._projectReaders.map(function (reader) { return reader.id; }), clearAfterSelect: true, isCreatable: true }))),
                        React.createElement("div", { className: styles.personList }, this._projectReaders.map(function (projectReader, i) { return (React.createElement("div", { className: styles.personListRow, key: i },
                            React.createElement(Person, { name: projectReader.displayName.split(' ')[0] || '', secondName: projectReader.displayName.split(' ')[1] || '' }),
                            React.createElement("div", null,
                                React.createElement(MdClose, { size: "20", onClick: function () { return _this._handleUserRemove(projectReader); } })))); })))))));
    };
    AddProjectReadersC.prototype._getFooterButtons = function () {
        return [
            {
                color: 'success',
                onClick: this._handleSave,
                disabled: !this._projectReaders || this._projectReaders.length === 0,
                title: 'Save'
            },
            {
                onClick: this._handleClose,
                title: 'Close'
            }
        ];
    };
    __decorate([
        observable
    ], AddProjectReadersC.prototype, "_projectReaders", void 0);
    __decorate([
        action.bound
    ], AddProjectReadersC.prototype, "_handleUserSelect", null);
    __decorate([
        action.bound
    ], AddProjectReadersC.prototype, "_handleUserRemove", null);
    __decorate([
        action.bound
    ], AddProjectReadersC.prototype, "_handleClose", null);
    __decorate([
        action.bound
    ], AddProjectReadersC.prototype, "_handleSave", null);
    __decorate([
        action.bound
    ], AddProjectReadersC.prototype, "_toggleModal", null);
    AddProjectReadersC = __decorate([
        observer
    ], AddProjectReadersC);
    return AddProjectReadersC;
}(React.PureComponent));
export var AddProjectReaders = withRouter(AddProjectReadersC);
